module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth-callback.component.scss
// module id = ./src/app/auth/auth-callback.component.scss
// module chunks = main